export {default as Rect} from "./Rect";
export {default as Size} from "./Size";
export {default as Point} from "./Point";
export {default as pixelRect} from "./pixelRect";



// WEBPACK FOOTER //
// ./src/shared/xp/geom/index.ts